export default (fragment) => {
	try {
		return require(`./${fragment}`).default;
	} catch (err) {
		console.error(`Undefined fragment "${fragment}"`);
		console.error(err);
		return null;
	}
};
